// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags-module--tags--2N5_L"};